import ReduxHelper from 'lib/ReduxHelper';
import { PARTIES_ACTION_TYPES as PAT } from './Parties.actions';
import { history } from '../Store';
import { isNullOrWhitespace } from 'vdlib';
import { APP_ACTION_TYPES } from '../app/App.actions';

export const defaultState = {
  error: null,
  filters: [],

  fetchingParties: false,
  partiesData: null,

  fetchingCurrentParty: false,
  currentParty: null,

  creatingParty: false,
  creationError: null,
  partyCreated: false,

  updatingParty: false,
  updateError: null,
  partyUpdated: false,

  deletingParty: false,
  deleteError: null,
  partyDeleted: false,

  changingStatusParty: false,
  partyStatusChangeError: null,
  partyStatusChanged: false,
};

const partiesReducer = (state = defaultState, action) => {
  const { error, payload, type } = action;
  switch (type) {
    case PAT.PARTIES_FETCH_DATA:
      return Object.assign({}, state, { fetchingParties: true });
    case PAT.PARTIES_FETCH_DATA_SUCCESS:
      return Object.assign({}, state, {
        fetchingParties: false,
        partiesData: payload.Parties,
        error: null,
      });
    case PAT.PARTIES_FETCH_DATA_FAIL:
      return Object.assign({}, state, {
        partiesData: null,
        error: ReduxHelper.extractError(action),
      });
    case PAT.PARTIES_CLEAR_DATA:
      return Object.assign({}, state, {
        fetchingParties: false,
        partiesData: null,
        error: null,
      });

    case PAT.PARTY_CREATE:
      return Object.assign({}, state, {
        creatingParty: true,
        partyCreated: false,
      });
    case PAT.PARTY_CREATE_SUCCESS:
      setTimeout(() => history.push({ pathname: '/all-parties' }));
      return Object.assign({}, state, {
        creatingParty: false,
        partyCreated: true,
      });
    case PAT.PARTY_CREATE_FAIL:
      return Object.assign({}, state, {
        creatingParty: false,
        creationError: error,
      });
    case PAT.PARTY_CREATE_CLEAR:
      return Object.assign({}, state, {
        creatingParty: false,
        creationError: null,
        partyCreated: false,
      });

    case PAT.PARTY_UPDATE:
      return Object.assign({}, state, {
        partyUpdated: false,
        updatingParty: true,
      });
    case PAT.PARTY_UPDATE_SUCCESS:
      setTimeout(() => history.push({ pathname: '/all-parties' }));
      return Object.assign({}, state, {
        updatingParty: false,
        partyUpdated: true,
      });
    case PAT.PARTY_UPDATE_FAIL:
      return Object.assign({}, state, {
        updatingParty: false,
        updateError: error,
      });
    case PAT.PARTY_UPDATE_CLEAR:
      return Object.assign({}, state, {
        updatingParty: false,
        updateError: null,
        partyUpdated: false,
      });

    case PAT.PARTY_DELETE:
      return Object.assign({}, state, { deletingParty: true });
    case PAT.PARTY_DELETE_SUCCESS:
      setTimeout(() => history.push({ pathname: '/all-parties' }));
      return Object.assign({}, state, {
        deletingParty: false,
        partyDeleted: true,
      });
    case PAT.PARTY_DELETE_FAIL:
      return Object.assign({}, state, {
        deletingParty: false,
        deleteError: error,
      });

    case PAT.PARTY_ENABLE_DISABLE:
      return Object.assign({}, state, { changingStatusParty: true });
    case PAT.PARTY_ENABLE_DISABLE_SUCCESS:
      setTimeout(() => history.push({ pathname: '/all-parties' }));
      return Object.assign({}, state, {
        changingStatusParty: false,
        partyStatusChanged: true,
      });
    case PAT.PARTY_ENABLE_DISABLE_FAIL:
      return Object.assign({}, state, {
        changingStatusParty: false,
        partyStatusChangeError: error,
      });

    case PAT.PARTY_FETCH:
      return Object.assign({}, state, { fetchingCurrentParty: true });
    case PAT.PARTY_FETCH_SUCCESS:
      return Object.assign({}, state, {
        fetchingCurrentParty: false,
        currentParty: payload.Parties[0],
        partyAppMembershipsData: payload.PartyAppMemberships,
      });
    case PAT.PARTY_FETCH_FAIL:
      return Object.assign({}, state, {
        fetchingCurrentParty: false,
        error: error || payload,
      });
    case PAT.PARTY_CLEAR:
      return Object.assign({}, state, {
        fetchingCurrentParty: false,
        currentParty: null,
        error: null,
      });

    case PAT.AUCTION_PARTY_FETCH:
      return Object.assign({}, state, {
        [`fetchingCurrent${payload.partyType}`]: true,
      });
    case PAT.AUCTION_PARTY_FETCH_SUCCESS:
      const { partyType, Parties } = payload;
      return Object.assign({}, state, {
        [`fetchingCurrent${partyType}`]: false,
        [`current${partyType}`]: Parties[0],
      });
    case PAT.AUCTION_PARTY_FETCH_FAIL:
      return Object.assign({}, state, {
        [`fetchingCurrent${payload.partyType}`]: false,
        error: error || payload,
      });
    case PAT.AUCTION_PARTY_CLEAR:
      return Object.assign({}, state, {
        [`fetchingCurrent${payload.partyType}`]: false,
        [`current${payload.partyTpe}`]: null,
        error: null,
      });

    case PAT.SET_PARTIES_GRID_FILTER:
      let newFilter = {
        Name: action.payload.name,
        Value: action.payload.value,
      };

      const existing = !!state.filters.find(f => f.Name === newFilter.Name);

      const newFilters =
        typeof newFilter.Value !== 'number' &&
        isNullOrWhitespace(newFilter.Value)
          ? state.filters.filter(f => f.Name !== newFilter.Name)
          : existing
          ? state.filters.map(f => (f.Name === newFilter.Name ? newFilter : f))
          : [...state.filters, newFilter];

      return {
        ...state,
        filters: newFilters,
      };

    case PAT.CLEAR_PARTIES_GRID_FILTER:
      return {
        ...state,
        filters: [],
      };

    case APP_ACTION_TYPES.LOGOUT:
      return defaultState;

    default:
      return state;
  }
};

export default partiesReducer;
